import { useEffect, useState, useMemo, useCallback } from "react";
import {
  Button,
  Box,
  Typography,
  CircularProgress,
  TextField,
  styled,
  MenuItem,
  debounce,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchGoalsData } from "../../../../action/userOwnGoals";
// import { fetchTounamentData } from "../../../../action/userOwnTournament";
import { fetchLeagueData } from "../../../../action/userOwnLeagues";
// import {} from "../../../../action/userOwnClubs";
import { toast } from "react-toastify";
import { isArray } from "jquery";
import TournamentVideoComponent from "./TournamentVideoComponent";
import VideoSkeleton from "../../Leaderboard/VideoSkeleton";
import moment from "moment";
import { useSkipFirstRender } from "../../../../hooks/useSkipFirstRender";
import CategoryComponent from "../../CategoryComponent/Index";
import { CustomTextarea } from "../../formComponents/CustomTextArea";
import { useDebounce } from "../../../../hooks/useCustomDebounce";
import { deleteTournament } from "../../../../api/deleteTournament";
import { deleteLeague } from "../../../../api/deleteLeague";

// static category check to show on filter
const statCatCheck = ["Men's Football", "Women's Football"];

const Index = ({ filterState }) => {
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.user);
  const myGoalsData = useSelector((state) => state.myGoals);
  const myTournamentsData = useSelector((state) => state.myLeagues);
  const [myGoals, setMyGoals] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const globalSearchData = useSelector((state) => state.globalSearch);
  const [yearMonth, setyearMonth] = useState("default");
  const goalCategories = useSelector((state) => state.goalCategories);
  const features = useSelector((state) => state.features);
  const [subFilter, setSubFilter] = useState("");
  const [childFilter, setChildFilter] = useState("");


  const fetchSearchResult = useCallback(
    (token, filter, user_id, key, subFilter, childFilter) => {
      // "";
      dispatch(
        fetchLeagueData(
          token,
          filter,
          user_id,
          key,
          {},
          { subFilter, childFilter },
        ),
      );
    },
  );

  const debouncedSearch = useDebounce(fetchSearchResult, 500);

  useEffect(() => {
    const year = yearMonth?.split("-")?.pop();
    const month = yearMonth?.split("-")[0];
    const yearData = { year, month };
    if (userData.data?.id && token) {
      debouncedSearch(
        token,
        filter,
        userData.data.id,
        globalSearchData.search,
        subFilter,
        childFilter,
      );
    }

  }, [globalSearchData]);

  useEffect(() => {
    if (token && userData?.data?.id) {
      dispatch(fetchLeagueData(token, filter, userData.data.id, ""));
    }
  }, []);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];
    if (token && userData?.data?.id) {
      setLoading(true);
      dispatch(
        fetchLeagueData(token, filter, userData.data.id, "", {
          year,
          month,
        }),
      );
    }
  }, [filter]);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];

    if (token && userData?.data?.id && subFilter) {
      setLoading(true);

      dispatch(
        fetchLeagueData(
          token,
          filter,
          userData.data.id,
          "",
          {
            year,
            month,
          },
          { subFilter, childFilter },
        ),
      );
    }
  }, [subFilter]);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];
    console.log(
      year,
      month,
      "on chang e thi sis ther yar and he month childfilter",
    );
    if (token && userData?.data?.id && childFilter) {
      setLoading(true);

      dispatch(
        fetchLeagueData(
          token,
          filter,
          userData.data.id,
          "",
          {
            year,
            month,
          },
          { subFilter, childFilter },
        ),
      );
    }
  }, [childFilter]);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];

    if (token && userData?.data?.id) {
      setLoading(true);

      dispatch(
        fetchLeagueData(
          token,
          filter,
          userData.data.id,

          "",
          {
            year,
            month,
          },
          { subFilter, childFilter },
        ),
      );
    }
  }, [yearMonth]);

  /// for my tournament

  /// for tournaments
  useEffect(() => {
    if (globalSearchData.search) {
      if (myTournamentsData.searchData?.success) {
        if (myTournamentsData.searchData?.data?.rows?.length > 0) {
          setMyGoals(myTournamentsData.searchData?.data.rows);
          setLoading(false);
        } else {
          setMyGoals("No Data Found");
          setLoading(false);
        }
      }
    } else {
      if (myTournamentsData.data?.success) {
        if (myTournamentsData.data?.data?.rows?.length > 0) {
          setMyGoals(myTournamentsData.data?.data?.rows);
          setLoading(false);
        } else {
          setMyGoals("No Data Found");
          setLoading(false);
        }
      }
    }

    if (myTournamentsData?.error) {
      toast.error("Error! Please try again.");
      setMyGoals("Please Try again");
      setLoading(false);
    }

    setLoading(myTournamentsData.loading);
  }, [myTournamentsData]);

  const deleteHandlerTournament = useCallback(
    async (data) => {
      const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
      const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];
      // if (data?.tournamentGoalVideos) {
      // setDeleting(true);
      const resData = await deleteLeague(data.id, token);
      if (resData?.success) {
        toast.success(resData?.message);
        const date = new Date();
        dispatch(
          fetchLeagueData(
            token,
            filter,
            userData.data.id,
            globalSearchData.search,
            {
              year,
              month,
            },
            { subFilter, childFilter },
          ),
        );
        // setDeleting(false);
      } else {
        // setDeleting(false);
        toast.error(resData);
      }
      // }
    },
    [yearMonth, childFilter, subFilter, globalSearchData],
  );

  return (
    <>
      {goalCategories.loading ? (
        <CircularProgress />
      ) : Array.isArray(goalCategories.data.data) ? (
        <CategoryComponent
          categories={goalCategories.data.data.filter((cat) =>
            statCatCheck.includes(cat.name),
          )}
          filter={filter}
          setFilter={setFilter}
          subFilter={subFilter}
          setSubFilter={setSubFilter}
          childFilter={childFilter}
          setChildFilter={setChildFilter}
          page={"MyAccount"}
          filterOn={"league"}
        />
      ) : (
        "No category data found"
      )}

      <Box
        className="Category-filter-wrapper"
        sx={{ justifyContent: "space-between" }}
      >
        <CustomTextarea
          select
          variant="outlined"
          name="previous_months"
          value={yearMonth}
          onChange={(e) => {
            if (e.target.value == "default") {
              setyearMonth("default");
              return;
            }

            setyearMonth(e.target.value);
          }}
          sx={{
            maxWidth: "200px",
            border: "1px solid #414466",
            padding: "7px",
            borderRadius: "8px",
          }}
        >
          <MenuItem value="default">Select Year</MenuItem>
          {Array.from({ length: 24 }).map((_, i) => (
            <MenuItem value={moment().subtract(i, "months").format("M-YYYY")}>
              {`${moment().subtract(i, "months").format("MMM YYYY")}`}
            </MenuItem>
          ))}
        </CustomTextarea>
      </Box>

      <Box className="leaderboard-data-wrapper">
        {loading ? (
          Array.from({ length: 10 }).map((ele) => <VideoSkeleton />)
        ) : isArray(myGoals) && myGoals.length > 0 ? (
          myGoals.map((ele, index) => {
            return (
              <>
                <TournamentVideoComponent
                  key={index}
                  data={ele}
                  filterState={filterState}
                  setData={setMyGoals}
                  deleteTournamentFunc={deleteHandlerTournament}
                />
              </>
            );
          })
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: "1",
            }}
            className="error-state"
          >
            <Typography component="p">{"NO Goals Found"}</Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default Index;
